import { httpWrapper } from 'services/http';
import userService from 'services/user';
import { endpoint } from '.';
import { API_URL_WALLET_INTERNAL, ENDPOINT_WIRE_TRANSFERS } from 'constants.js';

const read = async ({ pageNumber, pageSize, status, orderBy, filter } = {}) => {
  const authHeaders = await userService.getAuthorizationHeaders();
  const requestOptions = {
    method: 'GET',
    url: endpoint(ENDPOINT_WIRE_TRANSFERS, false, API_URL_WALLET_INTERNAL),
    headers: {
      ...authHeaders,
    },
    params: { pageNumber, pageSize, status, orderBy, filter },
  };

  const response = httpWrapper(requestOptions);
  return response;
};

const downloadProof = async wireTransferId => {
  const authHeaders = await userService.getAuthorizationHeaders();
  const requestOptions = {
    method: 'GET',
    url: endpoint(
      `${ENDPOINT_WIRE_TRANSFERS}/${wireTransferId}/proof/download`,
      false,
      API_URL_WALLET_INTERNAL,
    ),
    headers: {
      ...authHeaders,
    },
    responseType: 'arraybuffer',
  };

  const response = httpWrapper(requestOptions);
  return response;
};

const wireTransfers = { read, downloadProof };

export default wireTransfers;
